<!-- `relative` sits outside any clipping frame so the panel is never cut off. -->
<div class="relative w-full" (focusout)="onFocusOut($event)">
  <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none"
    stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
      d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" />
  </svg>

  <input #input type="text" [(ngModel)]="query" (ngModelChange)="onInput()" (keydown)="onKeydown($event)"
    (focus)="open.set(true)" placeholder="Search projects, tasks, to-dos, clients…"
    class="w-full pl-9 pr-16 py-1.5 rounded-lg text-sm text-gray-700 placeholder-gray-400 bg-gray-100/70 border border-transparent focus:outline-none focus:bg-white focus:border-gray-200 focus:ring-2 focus:ring-blue-500/15 transition-all" />

  <kbd class="absolute right-2.5 top-1/2 -translate-y-1/2 hidden sm:inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded border border-gray-200 bg-white text-[10px] font-medium text-gray-400 pointer-events-none">⌘K</kbd>

  @if(open() && query.trim()) {
  <div class="absolute left-0 right-0 top-full mt-2 bg-white border border-gray-200 rounded-xl shadow-xl z-[100] overflow-hidden max-h-[70vh] overflow-y-auto custom-scrollbar">

    @if(error) {
    <!-- A failure must read as a failure, not as "nothing found". -->
    <div class="flex items-start gap-2 p-3 bg-amber-50 border-b border-amber-100">
      <svg class="w-4 h-4 text-amber-600 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
      </svg>
      <p class="text-xs text-amber-800">{{ error }}</p>
    </div>
    }

    @if(loading() && !results()) {
    <div class="flex items-center gap-2 px-3 py-4 text-sm text-gray-400">
      <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      Searching…
    </div>
    }

    @else if(results(); as r) {
      @if(r.total === 0) {
      <div class="px-3 py-6 text-center">
        <p class="text-sm text-gray-500">No match for “{{ query }}”</p>
        <p class="text-xs text-gray-400 mt-0.5">Try a different term</p>
      </div>
      }

      @for(group of groups; track group.key) {
      @let hits = hitsFor(group.key);
      @if(hits.length) {
      <div class="px-3 pt-2.5 pb-1 text-[10px] font-bold uppercase tracking-wider text-gray-400">{{ group.label }}</div>
      @for(hit of hits; track hit.objectID) {
      @let idx = indexOf(hit);
      <button type="button" (mousedown)="$event.preventDefault(); go(hit)" (mouseenter)="active.set(idx)"
        class="w-full flex items-center gap-2.5 px-3 py-2 text-left transition-colors cursor-pointer"
        [class.bg-blue-50]="active() === idx" [class.hover:bg-gray-50]="active() !== idx">
        <span class="w-7 h-7 rounded-md bg-gray-100 flex items-center justify-center shrink-0">
          <svg class="w-3.5 h-3.5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="iconFor(hit.type)" />
          </svg>
        </span>
        <span class="min-w-0 flex-1">
          <span class="block text-sm font-medium text-gray-800 truncate">{{ hit.title }}</span>
          @if(hit.subtitle) {
          <span class="block text-[11px] text-gray-400 truncate">{{ hit.subtitle }}</span>
          }
        </span>
      </button>
      }
      }
      }
    }
  </div>
  }
</div>
